<div class="sp-subscription-plan-dropdown">
  <div class="sp-title-container">
    <span class="sp-dropdown" (click)="handleSpDropdown(spDropdown)">
      <mat-icon>shopping_cart_outline</mat-icon>
      Subscription plan
      @if (!isMobileDropdownOpened) {
        <mat-icon>keyboard_arrow_down</mat-icon>
      } @else {
        <mat-icon>keyboard_arrow_up</mat-icon>
      }
    </span>
    @if (subscriptionInfoPaymentModel) {
      <span class="sp-price">${{ subscriptionInfoPaymentModel.subscriptionPlanData.price }}</span>
    }
  </div>
  <div class="sp-body-container flex-direction-column align-items-center" #spDropdown [class]="isMobileDropdownOpened ? 'pb-18px' : ''">
    @if (isMobileDropdownOpened) {
      <ng-container [ngTemplateOutlet]="subscriptionPlanCardTemplateMobile"></ng-container>
    }
  </div>
</div>

<section class="flex-direction-row w-100 gap-20px">
  <div class="sp__card-select-section flex-direction-column width-60 sp-payment-method-container">
    <div class="py-payment mb-30px">
      <span class="py-title mb-14px">{{ 'payment.payment' | translate }}</span>
    </div>
    <div class="flex-direction-column gap-10px">
      <app-payment-type (selectType)="selectType(PaymentType.CREDIT_CARD)"
                        [isSelected]="paymentTypeSelected === PaymentType.CREDIT_CARD"
                        [paymentType]="PaymentType.CREDIT_CARD"
                        [translation]="true"></app-payment-type>
      @for(creditCard of creditCards; track creditCard) {
        <app-payment-type (selectType)="selectType(PaymentType.EXISTING_CREDIT_CARD, creditCard)"
                      [cardLastDigits]="creditCard.cardNumber"
                      [isSelected]="paymentTypeSelected === PaymentType.EXISTING_CREDIT_CARD && !!(selectedCreditCard) && creditCard.cardHolderId == selectedCreditCard.cardHolderId"
                      [paymentType]="PaymentType.EXISTING_CREDIT_CARD"
                      [translation]="true"></app-payment-type>
      }
      <app-payment-type (selectType)="selectType(PaymentType.APPLE_PAY)" [disabled]="true"
                        [isSelected]="paymentTypeSelected === PaymentType.APPLE_PAY"
                        [paymentType]="PaymentType.APPLE_PAY"
                        [translation]="true"></app-payment-type>
      <app-payment-type (selectType)="selectType(PaymentType.GOOGLE_PAY)" [disabled]="true"
                        [isSelected]="paymentTypeSelected === PaymentType.GOOGLE_PAY"
                        [paymentType]="PaymentType.GOOGLE_PAY"
                        [translation]="true"></app-payment-type>

      <div class="mt-4px payment_type_info">
        <div>
          <mat-icon class="payment_type_info_icon">info_outline</mat-icon>
        </div>

        <span>{{ 'payment.card_details_info' | translate }}</span>
      </div>
    </div>
    <div class="mt-30px d-flex justify-content-end">
      <button class="filled-button tall-button pay-button" [disabled]="isPayClicked" (click)="pay()">{{ 'payment.pay_now' | translate }}</button>
    </div>
  </div>

  <div class="plan-card-lg width-40">
    <ng-container [ngTemplateOutlet]="subscriptionPlanCardTemplate"></ng-container>
  </div>
</section>

<ng-template #subscriptionPlanCardTemplate>
  @if (subscriptionInfoPaymentModel) {
    <div class="sp__standard-card-container w-100 standard-card-container">
      <div class="standard-card">
        <div class="first-standard-card-layout">
          <div class="standard-card-icon-and-text-container">
            <div class="sp__standard-card-icon-container"
              [ngClass]="{'standard-card-icon-container-active': subscriptionInfoPaymentModel.isStandard, 'standard-card-icon-container': !subscriptionInfoPaymentModel.isStandard }">
              <img
                [src]="subscriptionInfoPaymentModel.isStandard ? '/assets/subscription-plan/icon-standard.svg' : (subscriptionInfoPaymentModel.isStarter ? '/assets/subscription-plan/icon-starter.svg' : '/assets/subscription-plan/icon-premium.svg')"
                class="standard-icon"
                [ngStyle]="{'transform': !subscriptionInfoPaymentModel.isIndividuals && subscriptionInfoPaymentModel.isStarter ? 'rotate(-45deg)' : (!subscriptionInfoPaymentModel.isIndividuals ? 'rotate(-90deg)' : 'rotate(0deg)')}"
                alt="icon">
            </div>
            <div class="standard-text" [attr.lang]="currentLang">
              {{ getTranslatedSubscriptionTitle(subscriptionInfoPaymentModel.subscriptionPlanData.subscriptionType) }}
            </div>
          </div>
          <br>
          <div class="standard-under-text">
            {{ subscriptionInfoPaymentModel.subscriptionPlanData.description | translate }}
          </div>
          <br>

      <div class="standard-card-cost-container" [ngClass]="{'discounted-price-container': (newPrice || newPrice == 0)}">
        <div class="text-decoration-line-through"></div>
        <div class="sp__card-cost"
          [ngClass]="{'standard-card-cost-active' : subscriptionInfoPaymentModel.isStandard, 'standard-card-cost' : !subscriptionInfoPaymentModel.isStandard,  'standard-card-cost-ru': currentLang === Language.RU, 'standard-card-cost-am': currentLang === Language.HY }">
          @if (subscriptionInfoPaymentModel.subscriptionPlanData.price === 0) {
          {{ FREE | translate }}
          } @else if (subscriptionInfoPaymentModel.isYearly) {
          ${{ subscriptionInfoPaymentModel.subscriptionPlanData.price * 10 }}
          } @else {
          ${{ subscriptionInfoPaymentModel.subscriptionPlanData.price }}
          }
        </div>

        @if (subscriptionInfoPaymentModel.subscriptionPlanData.price !== 0) {
          <div class="subscribe-duration-wrapper">
            <div class="amd-subscribe">
              @if (subscriptionInfoPaymentModel.isYearly) {
                {{ subscriptionInfoPaymentModel.subscriptionPlanData.price * 10 * DOLLAR_TO_DRAM_CURRENCY }} ֏
              } @else {
                {{ subscriptionInfoPaymentModel.subscriptionPlanData.price * DOLLAR_TO_DRAM_CURRENCY }} ֏
              }
            </div>
          </div>
          <div class="subscribe-duration-wrapper">
            <div class="subscribe-duration-slash">/</div>
            <div class="subscribe-duration">
              @if (!subscriptionInfoPaymentModel.isYearly) {
                {{ MONTHLY | translate }}
              } @else {
                {{ YEARLY | translate }}
              }
            </div>
          </div>
        }
      </div>

      @if (newPrice || newPrice == 0) {
        <div class="standard-card-cost-container">
          <div class="sp__card-cost"
            [ngClass]="{'standard-card-cost-active' : subscriptionInfoPaymentModel.isStandard, 'standard-card-cost' : !subscriptionInfoPaymentModel.isStandard,  'standard-card-cost-ru': currentLang === Language.RU, 'standard-card-cost-am': currentLang === Language.HY }">
            @if (subscriptionInfoPaymentModel.isYearly) {
              ${{ newPrice * 10 }}
            } @else {
              ${{ newPrice }}
            }
          </div>

          @if (subscriptionInfoPaymentModel.subscriptionPlanData.price !== 0) {
            <div class="subscribe-duration-wrapper">
              <div class="amd-subscribe">
                @if (subscriptionInfoPaymentModel.isYearly) {
                  {{ newPrice * 10 * DOLLAR_TO_DRAM_CURRENCY }} ֏
                } @else {
                  {{ roundPrice(newPrice * DOLLAR_TO_DRAM_CURRENCY) }} ֏
                }
              </div>
            </div>
            <div class="subscribe-duration-wrapper">
              <div class="subscribe-duration-slash">/</div>
              <div class="subscribe-duration">
                @if (!subscriptionInfoPaymentModel.isYearly) {
                  {{ MONTHLY | translate }}
                } @else {
                  {{ YEARLY | translate }}
                }
              </div>
            </div>
          }
        </div>
      }

  <div class="mt-20px" [ngClass]="subscriptionInfoPaymentModel.subscriptionPlanData.isStarter ? 'sub-plan-duration-starter' : 'sub-plan-duration'">
    <div>
      <span class="duration-title">{{ 'payment.starts' | translate }}</span>
      <span class="duration-date">{{ subscriptionInfoPaymentModel.startDate | date:'dd/MM/yyyy' }}</span>
        </div>
        @if (!subscriptionInfoPaymentModel.isStarter) {
          <div>
            <span class="duration-title">{{ 'payment.ends' | translate }}</span>
            <span class="duration-date">{{ subscriptionInfoPaymentModel.endDate | date:'dd/MM/yyyy' }}</span>
          </div>
        }
      </div>

</div>
</div>

<hr class="scan-hr">

<div class="flex-direction-column mt-20px justify-content-between w-100">
<label (click)="promoCodeInputField.click()" class="promo-code-input-field-label w-100">
<input #promoCodeInputField type="text" (input)="onPromoCodeInput()" [formControl]="promoCodeFormControl" placeholder="{{ 'payment.promo_code_messages' | translate }}">
<button class="ml-10px outlined-button tall-button" (click)="applyPromoCode()">{{ 'payment.apply' | translate }}</button>
</label>
@if(isPromoCodeInvalid) {
        <span class="error-message-span">{{getPromoCodeErrorMessage}}</span>
      }
    </div>
  </div>
}
</ng-template>

<ng-template #subscriptionPlanCardTemplateMobile>
  @if (subscriptionInfoPaymentModel) {
    <div class="sp__standard-card-container w-100 standard-card-container sp-standard-card-container-mb">
      <div class="standard-card">
        <div class="first-standard-card-layout">
          <div class="standard-card-icon-and-text-container">
            <div class="sp__standard-card-icon-container"
              [ngClass]="{'standard-card-icon-container-active': subscriptionInfoPaymentModel.isStandard, 'standard-card-icon-container': !subscriptionInfoPaymentModel.isStandard }">
              <img
                [src]="subscriptionInfoPaymentModel.isStandard ? '/assets/subscription-plan/icon-standard.svg' : (subscriptionInfoPaymentModel.isStarter ? '/assets/subscription-plan/icon-starter.svg' : '/assets/subscription-plan/icon-premium.svg')"
                class="standard-icon"
                [ngStyle]="{'transform': !subscriptionInfoPaymentModel.isIndividuals && subscriptionInfoPaymentModel.isStarter ? 'rotate(-45deg)' : (!subscriptionInfoPaymentModel.isIndividuals ? 'rotate(-90deg)' : 'rotate(0deg)')}"
                alt="icon">
            </div>
            <div class="standard-text" [attr.lang]="currentLang">
              {{ getTranslatedSubscriptionTitle(subscriptionInfoPaymentModel.subscriptionPlanData.subscriptionType) }}
            </div>
          </div>
          <br>
          <div class="standard-under-text">
            {{ subscriptionInfoPaymentModel.subscriptionPlanData.description | translate }}
          </div>
          <br>

      <div class="standard-card-cost-container" [ngClass]="{'discounted-price-container': (newPrice || newPrice == 0)}">
        <div class="text-decoration-line-through"></div>
        <div class="sp__card-cost"
          [ngClass]="{'standard-card-cost-active' : subscriptionInfoPaymentModel.isStandard, 'standard-card-cost' : !subscriptionInfoPaymentModel.isStandard,  'standard-card-cost-ru': currentLang === Language.RU, 'standard-card-cost-am': currentLang === Language.HY }">
          @if (subscriptionInfoPaymentModel.subscriptionPlanData.price === 0) {
  {{ FREE | translate }}
  } @else if (subscriptionInfoPaymentModel.isYearly) {
  ${{ subscriptionInfoPaymentModel.subscriptionPlanData.price * 10 }}
  } @else {
  ${{ subscriptionInfoPaymentModel.subscriptionPlanData.price }}
  }
  </div>

  @if (subscriptionInfoPaymentModel.subscriptionPlanData.price !== 0) {
  <div class="subscribe-duration-wrapper">
    <div class="amd-subscribe">
      @if (subscriptionInfoPaymentModel.isYearly) {
      {{ subscriptionInfoPaymentModel.subscriptionPlanData.price * 10 * DOLLAR_TO_DRAM_CURRENCY }} ֏
      } @else {
      {{ subscriptionInfoPaymentModel.subscriptionPlanData.price * DOLLAR_TO_DRAM_CURRENCY }} ֏
      }
    </div>
  </div>
  <div class="subscribe-duration-wrapper">
    <div class="subscribe-duration-slash">/</div>
    <div class="subscribe-duration">
      @if (!subscriptionInfoPaymentModel.isYearly) {
      {{ MONTHLY | translate }}
      } @else {
      {{ YEARLY | translate }}
      }
    </div>
  </div>
  }
  </div>

  @if (newPrice || newPrice == 0) {
  <div class="standard-card-cost-container">
    <div class="sp__card-cost"
         [ngClass]="{'standard-card-cost-active' : subscriptionInfoPaymentModel.isStandard, 'standard-card-cost' : !subscriptionInfoPaymentModel.isStandard,  'standard-card-cost-ru': currentLang === Language.RU, 'standard-card-cost-am': currentLang === Language.HY }">
      @if (subscriptionInfoPaymentModel.isYearly) {
      ${{ newPrice * 10 }}
      } @else {
      ${{ newPrice }}
      }
    </div>

    @if (subscriptionInfoPaymentModel.subscriptionPlanData.price !== 0) {
    <div class="subscribe-duration-wrapper">
      <div class="amd-subscribe">
        @if (subscriptionInfoPaymentModel.isYearly) {
    {{ newPrice * 10 * DOLLAR_TO_DRAM_CURRENCY }} ֏
    } @else {
    {{ roundPrice(newPrice * DOLLAR_TO_DRAM_CURRENCY) }} ֏
    }
    </div>
  </div>
  <div class="subscribe-duration-wrapper">
    <div class="subscribe-duration-slash">/</div>
    <div class="subscribe-duration">
      @if (!subscriptionInfoPaymentModel.isYearly) {
    {{ MONTHLY | translate }}
    } @else {
    {{ YEARLY | translate }}
    }
    </div>
  </div>
    }
  </div>
  }

      <div class="mt-20px" [ngClass]="subscriptionInfoPaymentModel.subscriptionPlanData.isStarter ? 'sub-plan-duration-starter' : 'sub-plan-duration'">
        <div>
          <span class="duration-title">{{ 'payment.starts' | translate }}</span>
          <span class="duration-date">{{ subscriptionInfoPaymentModel.startDate | date:'dd/MM/yyyy' }}</span>
        </div>
        @if (!subscriptionInfoPaymentModel.isStarter) {
          <div>
            <span class="duration-title">{{ 'payment.ends' | translate }}</span>
            <span class="duration-date">{{ subscriptionInfoPaymentModel.endDate | date:'dd/MM/yyyy' }}</span>
          </div>
        }
      </div>

</div>
</div>
</div>

<div class="flex-direction-column mt-20px justify-content-between sp-promo-code-container-mb">
<label (click)="promoCodeInputField.click()" class="promo-code-input-field-label promo-code-input-field-label-mb">
<input #promoCodeInputField type="text" (input)="onPromoCodeInput()" [formControl]="promoCodeFormControl" placeholder="{{ 'payment.promo_code' | translate }}">
<button class="ml-10px outlined-button tall-button" (click)="applyPromoCode()">{{ 'payment.apply' | translate }}</button>
</label>
@if(isPromoCodeInvalid) {
    <span class="error-message-span">{{getPromoCodeErrorMessage}}</span>
  }
</div>

}
</ng-template>
